import React from 'react';
import { MapPin, ShieldCheck, PhoneCall, Globe2, CheckCircle2 } from 'lucide-react';
import './AboutUs.css';

const FEATURES = [
    {
        icon: Globe2,
        title: 'Pan-India Travel B2B Network',
        description: 'Connect with travel B2B service providers across India — from Kashmir to Kanyakumari.'
    },
    {
        icon: ShieldCheck,
        title: 'Verified Service Providers',
        description: 'All vendors on TravelB2B Hub are verified through mobile authentication to ensure genuine and reliable listings.'
    },
    {
        icon: PhoneCall,
        title: 'Direct Vendor Connection',
        description: 'Contact service providers directly via WhatsApp or call — no intermediaries, no commissions.'
    },
    {
        icon: MapPin,
        title: 'Open & Free Platform',
        description: 'Post or explore travel B2B services without mandatory registration or hidden fees.'
    }
];

const AboutUs = () => {
    return (
        <div className="about-page">
            {/* Hero Section */}
            <section className="about-hero">
                <div className="container">
                    <h1 className="about-title">About Us</h1>
                    <p className="about-subtitle">India’s Open Travel B2B Service Platform</p>
                </div>
            </section>

            {/* Intro Section - Split Layout */}
            <section className="intro-section">
                <div className="intro-grid">
                    <div className="intro-content">
                        <span className="intro-badge">India's #1 Travel B2B Platform</span>
                        <h2>Welcome to India's Growing Travel B2B Service Hub</h2>
                        <p>
                            Built to connect travel professionals directly with verified service providers across the country.
                            Our platform is designed to simplify B2B travel sourcing by allowing vendors to list their services openly
                            and enabling buyers to connect instantly — without registrations, commissions, or intermediaries.
                        </p>
                        <p>
                            Whether you are a travel agent looking for reliable partners or a service provider offering hotels,
                            transport, visa assistance, or destination services, we make collaboration faster and more transparent.
                        </p>
                        <div className="intro-stats">
                            <div className="stat-item">
                                <span className="stat-number">10+</span>
                                <span className="stat-label">Service Providers</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-number">10+</span>
                                <span className="stat-label">Categories</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-number">Pan-India</span>
                                <span className="stat-label">Coverage</span>
                            </div>
                        </div>
                    </div>
                    <div className="intro-image-wrapper">
                        <div className="intro-image-container">
                            <img
                                src="/images/b2b-concept.jpg"
                                alt="TravelB2B Hub - India's B2B Travel Service Network"
                                className="intro-banner"
                            />
                            <div className="image-decoration"></div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container about-content">

                {/* What We Do */}
                <section className="about-section">
                    <h2 className="section-title-accent">What We Do</h2>
                    <p className="section-intro">We provide a single platform for all travel B2B services in India, where:</p>
                    <ul className="what-we-do-list">
                        <li>
                            <CheckCircle2 className="list-icon" size={20} />
                            <span>Service providers can post their offerings freely</span>
                        </li>
                        <li>
                            <CheckCircle2 className="list-icon" size={20} />
                            <span>Travel agents can explore services by category and location</span>
                        </li>
                        <li>
                            <CheckCircle2 className="list-icon" size={20} />
                            <span>Direct communication happens via WhatsApp or call</span>
                        </li>
                        <li>
                            <CheckCircle2 className="list-icon" size={20} />
                            <span>No sign-up is required to view or connect with vendors</span>
                        </li>
                    </ul>
                    <p className="vision-statement">
                        Our goal is to remove complexity from the travel B2B ecosystem and make sourcing services quick, reliable, and cost-effective.
                    </p>
                </section>

                {/* Our Vision */}
                <section className="about-section vision-section">
                    <div className="vision-box">
                        <h2>Our Vision</h2>
                        <p>
                            To become India’s most trusted travel B2B service hub, empowering travel businesses of all sizes —
                            from independent vendors to established agencies — by enabling direct connections, fair deals, and nationwide reach.
                        </p>
                    </div>
                </section>

                {/* Why Choose Us */}
                <section className="about-section why-choose-section">
                    <h2 className="text-center">Why Choose TravelB2B Hub?</h2>
                    <div className="features-grid-4">
                        {FEATURES.map((feature, index) => (
                            <div key={index} className="feature-item">
                                <div className="feature-icon-wrapper">
                                    <feature.icon size={32} strokeWidth={1.5} />
                                </div>
                                <h3>{feature.title}</h3>
                                <p>{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AboutUs;
